import { render, staticRenderFns } from "./Epub_reader.vue?vue&type=template&id=fc3228e6"
import script from "./Epub_reader.vue?vue&type=script&lang=js"
export * from "./Epub_reader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports